import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib"; // 管理对应 days

import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import CalendarNav from './CalendarNav.vue';
import CalendarPaneDay from './CalendarPaneDay.vue';
import SvgIcon from './SvgIcon.vue';
import { isDayDisable, isMonthDisable, pageForDate } from './utils/utils';

var CalendarPane = /*#__PURE__*/function (_Vue) {
  _inherits(CalendarPane, _Vue);

  var _super = _createSuper(CalendarPane);

  function CalendarPane() {
    var _this;

    _classCallCheck(this, CalendarPane);

    _this = _super.call(this);
    _this.isInPopover = false;
    _this.weekdayLabel = ['日', '一', '二', '三', '四', '五', '六'];
    _this.month = _this.$moment().format('YYYY/MM');
    return _this;
  }

  _createClass(CalendarPane, [{
    key: "pageChange",
    value: function pageChange(page) {
      return page;
    }
  }, {
    key: "prevClick",
    value: function prevClick() {}
  }, {
    key: "nextClick",
    value: function nextClick() {}
  }, {
    key: "monthChange",
    value: function monthChange(val) {
      this.month = val;
      this.pageChange(pageForDate(val));
    } // TOD 上个月

  }, {
    key: "handlePrevClick",
    value: function handlePrevClick() {
      this.month = this.$moment(this.month).subtract(1, 'M').format('YYYY-MM');
      this.prevClick();
    } // TOD 下个月

  }, {
    key: "handleNextClick",
    value: function handleNextClick() {
      this.month = this.$moment(this.month).add(1, 'M').format('YYYY-MM');
      this.nextClick();
    } // 获取某月日期组成

  }, {
    key: "getDaysForPage",
    value: function getDaysForPage(year, month) {
      var list = [];
      var monthMinus = month - 1;
      var prevMonth = monthMinus - 1 < 0 ? 11 : monthMinus - 1;
      var nextMonth = monthMinus + 1 > 11 ? 0 : monthMinus + 1;
      var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
        daysInMonth[1] = 29;
      }

      var targetIndex = new Date(year, monthMinus, 1).getDay();
      var prevMonthDayCnt = targetIndex;

      if (targetIndex > 0) {
        for (var i = prevMonthDayCnt; i > 0; i--) {
          var obj = {
            id: "".concat(year, "-").concat(prevMonth + 1, "-").concat(daysInMonth[prevMonth] - i + 1),
            inMonth: false,
            label: (daysInMonth[prevMonth] - i + 1).toString()
          };
          list.push(obj);
        }
      }

      for (var _i = 0; _i < daysInMonth[monthMinus]; _i++) {
        var _obj = {
          id: "".concat(year, "-").concat(monthMinus + 1, "-").concat(_i + 1),
          inMonth: true,
          label: "0".concat(_i + 1).slice(-2)
        };
        _obj.isDisable = isDayDisable(_obj.id, this.minDate);
        _obj.highlight = this.highlightDays.indexOf(_obj.id) !== -1;
        list.push(_obj);
      }

      var nextMonthDayCnt = 6 - new Date(year, nextMonth, 0).getDay();

      for (var _i2 = 0; _i2 < nextMonthDayCnt; _i2++) {
        var _obj2 = {
          id: "".concat(year, "-").concat(nextMonth + 1, "-").concat(_i2 + 1),
          inMonth: false,
          label: "0".concat(_i2 + 1)
        };
        list.push(_obj2);
      }

      return list;
    }
  }, {
    key: "isPrevDisable",
    get: function get() {
      if (!this.minDate) return false;
      return isMonthDisable({
        year: this.page.year,
        month: this.page.month - 1
      }, this.minDate);
    }
  }, {
    key: "daysInMonth",
    get: function get() {
      return this.getDaysForPage(this.page.year, this.page.month);
    }
  }, {
    key: "dateContent",
    get: function get() {
      return this.$moment(this.month).format('YYYY-MM');
    }
  }]);

  return CalendarPane;
}(Vue);

__decorate([Prop({
  type: Object,
  required: true
})], CalendarPane.prototype, "activeDate", void 0);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], CalendarPane.prototype, "highlightDays", void 0);

__decorate([Prop({
  type: [String, Date]
})], CalendarPane.prototype, "minDate", void 0);

__decorate([Prop({
  type: Object,
  default: function _default() {
    return {
      year: 2020,
      month: 1
    };
  }
})], CalendarPane.prototype, "page", void 0);

__decorate([Emit('monthChange')], CalendarPane.prototype, "pageChange", null);

__decorate([Emit('prevClick')], CalendarPane.prototype, "prevClick", null);

__decorate([Emit('nextClick')], CalendarPane.prototype, "nextClick", null);

CalendarPane = __decorate([Component({
  components: {
    CalendarNav: CalendarNav,
    CalendarPaneDay: CalendarPaneDay,
    SvgIcon: SvgIcon
  }
})], CalendarPane);
export default CalendarPane;